document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".newsletter-popup");
  if (!popup) return;

  const delay = Number(popup.dataset.delay || 0) * 1000;
  const showOnce = popup.dataset.showOnce === "true";
  const storageKey = "newsletter-popup-shown";

  const overlay = popup.querySelector(".newsletter-popup__overlay");
  const closeBtn = popup.querySelector(".newsletter-popup__close");
  const form = popup.querySelector("form");
  const submitBtn = form?.querySelector('button[type="submit"]');

  const successMessage = popup.querySelector(".newsletter-popup__success");
  const errorMessage = popup.querySelector(".newsletter-popup__errors");

  function lockScroll(lock) {
    document.body.style.overflow = lock ? "hidden" : "";
  }

  function openPopup() {
    if (popup.classList.contains("active")) return;

    popup.classList.add("active");
    lockScroll(true);
  }

  function closePopup() {
    popup.classList.remove("active");
    lockScroll(false);

    if (showOnce) {
      localStorage.setItem(storageKey, "true");
    }
  }

  // If Shopify rendered a success or error message,
  // always show the popup regardless of localStorage.
  if (successMessage || errorMessage) {
    openPopup();
  } else {
    // Normal popup logic
    if (!showOnce || localStorage.getItem(storageKey) !== "true") {
      setTimeout(openPopup, delay);
    }
  }

  closeBtn?.addEventListener("click", closePopup);
  overlay?.addEventListener("click", closePopup);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.classList.contains("active")) {
      closePopup();
    }
  });

  if (form && submitBtn) {
    form.addEventListener("submit", () => {
      submitBtn.classList.add("is-loading");

      const label = submitBtn.querySelector(".push-btn__surface");

      if (label) {
        label.textContent = "Submitting...";
      } else {
        submitBtn.textContent = "Submitting...";
      }
    });
  }
});